import * as React from "react";
import { Card } from "antd";
import { CardTitle } from "../../../components/antd/card/CardTitle";
import { CardContent } from "../../../components/antd/card/CardContent";
import { SecretTypeOptions } from "../utils";
import { CpSelect } from "../../gvc/testNewForm/CpSelect";
import { CpErrorWarning } from "../../gvc/testNewForm/CpErrorWarning";
import { CpLabel } from "../../gvc/testNewForm/CpLabel";
import { CpFormItem } from "../../gvc/testNewForm/CpFormItem";
import { CpInputDescription } from "../../gvc/testNewForm/CpInputDescription";
import { CpInput } from "../../gvc/testNewForm/CpInput";
import { CpErrorWarningArrayIcon } from "../../gvc/testNewForm/CpErrorWarningArrayIcon";
import { CpLabelTooltip } from "../../gvc/testNewForm/CpLabelTooltip";
import { CpTooltip } from "../../gvc/testNewForm/CpTooltip";

export const General: React.FC = () => {
  return (
    <>
      <div className="cpln-form-section cpln-ant-card-container">
        <Card>
          <CardTitle>
            Secret
            <CpErrorWarningArrayIcon names={["name", "description"]} />
          </CardTitle>
          <CardContent>
            <CpFormItem>
              <CpLabelTooltip>
                <CpLabel name={`name`}>Name</CpLabel>
                <CpTooltip tooltipProps={{ title: "Cannot be changed after creation (ok, my-item, item1)" }} />
              </CpLabelTooltip>
              <CpInput name={`name`} style={{ maxWidth: 600 }} />
              <CpErrorWarning name={`name`} />
            </CpFormItem>
            <CpInputDescription namePath="name" descriptionPath="description" />
            <CpFormItem>
              <CpLabelTooltip>
                <CpLabel name="type">Type</CpLabel>
                <CpTooltip
                  tooltipProps={{
                    title: `Select one of the supported secret types. If there is no fit for your data, Dictionary or Opaque is a
                more general choice.`,
                  }}
                />
              </CpLabelTooltip>
              <CpSelect name="type" options={SecretTypeOptions} style={{ maxWidth: 600 }} />
              <CpErrorWarning name="type" />
            </CpFormItem>
          </CardContent>
        </Card>
      </div>
    </>
  );
};
